// src/data/products.js
// Array de productos Hyundai para la página de producto

const products = [
  {
    id: "glory_500",
    name: "Glory 500",
    description: "La nueva Glory 500 es una SUV compacta que combina diseño deportivo, tecnología y rendimiento.",
    image: require("assets/images/dfsk/full/glory_500.png"),
    section: [
      {
        title: "Exterior",
        description: "Diseño, prestaciones de suspensión y detalles que resaltan su carácter deportivo.",
        caracteristics: [
          {
            title: "Diseño deportivo",
            description: "La estética fusiona líneas aerodinámicas con un estilo dinámico. Con detalles contemporáneos y un perfil robusto."
          },
          {
            title: "Llantas de aleación de 17 pulgadas",
            description: "Mejoran la estabilidad y el rendimiento en diferentes tipos de terreno."
          }
        ]
      },
      {
        title: "Interior",
        description: "Materiales de calidad, ergonomía y espacio para distintos usos.",
        caracteristics: [
          {
            title: "Diseño moderno",
            description: "Interior ergonómico y elegante, con materiales de calidad y detalles de terminación que realzan la comodidad."
          },
          {
            title: "Tecnología intuitiva",
            description: "Pantalla táctil con interfaz de manejo rápida y amigable."
          },
          {
            title: "Espacio versátil",
            description: "Los asientos abatibles permiten adaptar el vehículo a diferentes necesidades de viaje."
          }
        ]
      },
      {
        title: "Seguridad",
        description: "Equipamiento de seguridad activa pensado para garantizar control y protección.",
        caracteristics: [
          {
            title: "Airbags",
            description: "Dos airbags, conductor y acompañante."
          },
          {
            title: "Frenos a disco en las 4 ruedas",
            description: "Sistema de discos en las cuatro ruedas para mayor eficacia de frenado."
          },
          {
            title: "Control de tracción",
            description: "Ayuda a mantener el control en curvas cerradas o superficies resbaladizas."
          }
        ]
      }
    ]
  },
  {
    id: "glory_580",
    name: "Glory 580",
    description: "SUV de 7 pasajeros con confort, espacio y tecnología para viajes y familia.",
    image: require("assets/images/dfsk/full/glory_580.png"),
    section: [
      {
        title: "Confort y tecnología",
        description: "Equipamiento moderno y detalles de diseño para una experiencia premium a bordo.",
        caracteristics: [
          {
            title: "Diseño moderno y sofisticado",
            description: "Combinación de elegancia y funcionalidad con un diseño aerodinámico y detalles refinados."
          },
          {
            title: "Neumáticos con llantas de aleación",
            description: "Mejoran apariencia, estabilidad y rendimiento en carretera."
          },
          {
            title: "Entretenimiento con pantalla integrada",
            description: "Pantalla táctil compatible con múltiples funciones multimedia."
          }
        ]
      },
      {
        title: "Interior",
        description: "Espacio generoso, confort para todos los ocupantes, ideal para viajes largos.",
        caracteristics: [
          {
            title: "Capacidad de carga de 375 litros",
            description: "Baúl con capacidad de 375 litros, y se transforma al abatir los asientos traseros."
          },
          {
            title: "Confort",
            description: "Últimos accesorios orientados a mejorar la experiencia a bordo."
          },
          {
            title: "3 filas de asientos",
            description: "Tres filas de asientos para ubicar hasta siete personas con comodidad."
          }
        ]
      },
      {
        title: "Seguridad",
        description: "Protección activa y pasiva para ocupantes, visión trasera, y control de frenado.",
        caracteristics: [
          {
            title: "4 airbags",
            description: "Protección frontal y lateral para conductor y acompañante."
          },
          {
            title: "Cámara y sensor de retroceso",
            description: "Asistentes para maniobras de estacionar y retroceder."
          },
          {
            title: "Frenos ABS + EBD",
            description: "Sistema ABS con distribución electrónica del frenado (EBD)."
          }
        ]
      }
    ]
  },
  {
    id: "C31",
    name: "C31",
    description: "Compacto, ágil y confortable.",
    image: require("assets/images/dfsk/full/c31.png"),
    section: [
      {
        title: "Seguridad & Performance",
        description: "Motor, protección para conductor y acompañante, frenos y tecnología básica para uso comercial.",
        caracteristics: [
          {
            title: "Motor 1.5L de 101 Cv",
            description: "Tecnología del motor Multipoint EFI."
          },
          {
            title: "Transmisión MT (5 velocidades)",
            description: "Caja manual de 5 marchas."
          },
          {
            title: "ABS + EBD",
            description: "Frenos antibloqueo y distribución electrónica del frenado."
          },
          {
            title: "Doble airbag frontal",
            description: "Protección para conductor y acompañante."
          },
          {
            title: "Alarma de cinturón de seguridad",
            description: "Sistema de alerta si no se abrocha el cinturón."
          },
          {
            title: "ESP",
            description: "Sistema de estabilidad electrónica."
          }
        ]
      },
      {
        title: "Equipamiento exterior",
        description: "Elementos de iluminación, espejos, y capacidad de carga adaptados al uso comercial.",
        caracteristics: [
          {
            title: "Faros antiniebla delanteros y traseros",
            description: "Mayor visibilidad en condiciones adversas."
          },
          {
            title: "Espejos retrovisores exteriores",
            description: "Visibilidad mejorada con espejos exteriores."
          },
          {
            title: "Capacidad de carga de 1000 kg",
            description: "Alto peso útil para su segmento comercial."
          }
        ]
      },
      {
        title: "Equipamiento interior",
        description: "Comodidades básicas, aire, audio y confort para jornadas de trabajo.",
        caracteristics: [
          {
            title: "Radio + MP3 + SD",
            description: "Sistema de audio con entradas MP3 y SD."
          },
          {
            title: "Levantavidrios eléctricos",
            description: "Vidrios delanteros eléctricos."
          },
          {
            title: "Aire acondicionado",
            description: "Climatización para mayor confort interior."
          }
        ]
      }
    ]
  },
  {
    id: "C32",
    name: "C32",
    description: "Versatilidad, potencia y carga.",
    image: require("assets/images/dfsk/full/c32.png"),
    section: [
      {
        title: "Seguridad & Performance",
        description: "Motor similar al C31, protección y equipamiento para condiciones de trabajo exigentes.",
        caracteristics: [
          {
            title: "Motor 1.5L de 101 Cv",
            description: "Tecnología del motor Multipoint EFI."
          },
          {
            title: "Transmisión MT (5 velocidades)",
            description: "Caja manual de cinco marchas."
          },
          {
            title: "ABS + EBD",
            description: "Frenos antibloqueo con distribución electrónica del frenado."
          },
          {
            title: "Doble airbag frontal",
            description: "Protección para conductor y acompañante."
          },
          {
            title: "Alarma en cinturón de seguridad",
            description: "Sistema de alerta por cinturon."
          },
          {
            title: "ESP",
            description: "Sistema de estabilidad electrónica."
          }
        ]
      },
      {
        title: "Equipamiento exterior",
        description: "Iluminación, visibilidad y capacidad de carga para tareas comerciales.",
        caracteristics: [
          {
            title: "Faros antiniebla delanteros y traseros",
            description: "Mayor visibilidad en condiciones adversas."
          },
          {
            title: "Espejos retrovisores exteriores",
            description: "Visibilidad mejorada con espejos exteriores."
          },
          {
            title: "Capacidad de carga de 1000 kg",
            description: "Peso útil significativo para su categoría comercial."
          }
        ]
      },
      {
        title: "Equipamiento interior",
        description: "Funciones básicas para confort y trabajo diario.",
        caracteristics: [
          {
            title: "Radio + MP3 + SD",
            description: "Sistema de audio con soporte MP3 y SD."
          },
          {
            title: "Levantavidrios eléctricos (2)",
            description: "Vidrios delanteros eléctricos delanteros."
          },
          {
            title: "Aire acondicionado",
            description: "Climatización para confort interior."
          }
        ]
      }
    ]
  },
  {
    id: "C35",
    name: "C35",
    description: "La cargo van que ofrece espacio, flexibilidad y funcionalidad para impulsar tu negocio.",
    image: require("assets/images/dfsk/full/c35.png"),
    section: [
      {
        title: "Seguridad & Performance",
        description: "Características mecánicas y de seguridad equivalentes al resto de comerciales, con extras adicionales en visibilidad y respaldo para carga.",
        caracteristics: [
          {
            title: "Motor 1.5L de 101 Cv",
            description: "Tecnología del motor Multipoint EFI."
          },
          {
            title: "Transmisión MT (5 velocidades)",
            description: "Caja manual de cinco marchas."
          },
          {
            title: "ABS + EBD",
            description: "Frenos antibloqueo y distribución electrónica del frenado."
          },
          {
            title: "Doble airbag frontal",
            description: "Protección para conductor y acompañante."
          },
          {
            title: "Alarma en cinturón de seguridad",
            description: "Sistema de alerta por cinturon."
          },
          {
            title: "Cámara de retroceso",
            description: "Asistente visual para maniobras posteriores."
          },
          {
            title: "ESP",
            description: "Sistema de estabilidad electrónica."
          }
        ]
      },
      {
        title: "Equipamiento exterior",
        description: "Visibilidad e iluminación, espejos y capacidad de carga para uso intensivo.",
        caracteristics: [
          {
            title: "Faros antiniebla delanteros y traseros",
            description: "Mayor visibilidad en condiciones adversas."
          },
          {
            title: "Espejos retrovisores exteriores",
            description: "Visibilidad mejorada con espejos exteriores."
          },
          {
            title: "Capacidad de carga de 1000 kg",
            description: "Alta capacidad útil para transporte comercial."
          }
        ]
      },
      {
        title: "Equipamiento interior",
        description: "Funciones de confort superior: multimedia, caja de audio extra, pantalla y climatización.",
        caracteristics: [
          {
            title: "Radio + MP3 + SD",
            description: "Sistema de audio con entradas MP3 y SD."
          },
          {
            title: "Levantavidrios eléctricos (2)",
            description: "Vidrios eléctricos delanteros."
          },
          {
            title: "Aire acondicionado",
            description: "Climatización interior para confort."
          },
          {
            title: "Pantalla multimedia 10″",
            description: "Pantalla integrada de 10 pulgadas para funciones multimedia."
          }
        ]
      }
    ]
  },
  {
    id: "eC31",
    name: "eC31",
    description: "Vehículo comercial 100% eléctrico, ideal para transporte ligero con capacidad de carga, eficiente y con bajo impacto ambiental.",
    image: require("assets/images/dfsk/full/ec31.png"),
    section: [
      {
        title: "Exterior / Capacidad",
        description: "Alta capacidad de carga útil y volumen adaptados al uso comercial pesado ligero.",
        caracteristics: [
          {
            title: "Carga útil hasta 1,280 kg",
            description: "Permite transportar hasta 1.280 kg de carga."
          },
          {
            title: "Volumen de carga de 6.8 m³",
            description: "Espacio interior para carga de 6.8 metros cúbicos."
          }
        ]
      },
      {
        title: "Autonomía y rendimiento",
        description: "Funciones eléctricas de autonomía, tiempos de recarga y cargadores compatibles.",
        caracteristics: [
          {
            title: "Rango eléctrico puro de hasta 267 km",
            description: "Autonomía estimada según ciclo WLTP."
          },
          {
            title: "Recarga al 100% en 90 min / 80% en 60 min",
            description: "Capacidad de carga rápida para uso frecuente."
          },
          {
            title: "Cargador CCS2 y cable Tipo 2",
            description: "Compatibilidad estándar para estaciones de carga tanto CA como CC."
          }
        ]
      },
      {
        title: "Interior / Confort",
        description: "Tecnología multimedia y confort adaptado a largas jornadas laborales.",
        caracteristics: [
          {
            title: "Pantalla de 9\" con Android Auto y Apple CarPlay",
            description: "Integrada en centro del tablero; incluye cámara de retroceso visible en esta pantalla."
          },
          {
            title: "Interior amplio con extras multimedia",
            description: "Diseño interior pensado para confort y tecnología a bordo."
          }
        ]
      },
      {
        title: "Seguridad",
        description: "Sistemas de protección esenciales, estabilización y visibilidad.",
        caracteristics: [
          {
            title: "Airbags frontales",
            description: "Protección para conductor y acompañante."
          },
          {
            title: "ABS",
            description: "Frenos antibloqueo que ayudan en detenciones de emergencia."
          },
          {
            title: "Control electrónico de estabilidad",
            description: "Ayuda a mantener estabilidad en maniobras críticas."
          }
        ]
      }
    ]
  },
  {
      id: "K01H",
      name: "K01H",
      description: "Versatilidad, seguridad y rendimiento. Vehículo de trabajo con capacidad optimizada, cabina extendida, neumáticos adecuados, pantalla de 9\" y equipamiento pensado para uso comercial.",
      image: require("assets/images/dfsk/full/k01h.png"),
      section: [
        {
          title: "Exterior",
          description: "Gran capacidad de carga, cabina extendida, neumáticos robustos para diversas condiciones de manejo.",
          caracteristics: [
            {
              title: "Cable cabina extendida",
              description: "La cabina extendida permite mayor comodidad para el conductor y su acompañante."
            },
            {
              title: "Neumáticos 165/70 R13",
              description: "Tamaño 165/70 R13 para buena estabilidad y maniobrabilidad urbana y rural."
            },
            {
              title: "Faros antiniebla delanteros y traseros",
              description: "Equipamiento para mejorar visibilidad en condiciones adversas."
            }
          ]
        },
        {
          title: "Interior & tecnología",
          description: "Espacio funcional, con pantalla 9”, almacenamiento práctico y comodidades pensadas para jornadas de trabajo.",
          caracteristics: [
            {
              title: "Pantalla de 9\"",
              description: "Pantalla multifunción de 9 pulgadas; incluye cámara de retroceso visible en esta pantalla."
            },
            {
              title: "Almacenamiento práctico",
              description: "Compartimentos para herramientas u objetos pequeños, ideal para uso comercial."
            }
          ]
        },
        {
          title: "Seguridad",
          description: "Protección esencial con airbags, ópticas mejoradas, visibilidad y elementos pasivos que suman seguridad.",
          caracteristics: [
            {
              title: "Doble airbag frontal",
              description: "Airbags para conductor y acompañante como protección básica."
            },
            {
              title: "Ópticas estilo diamante",
              description: "Ópticas delanteras mejoradas para máxima visibilidad, incluso de noche o en baja luminosidad."
            },
            {
              title: "Faros antiniebla",
              description: "Incluye faros antiniebla traseros dobles para mejor visibilidad en condiciones adversas."
            }
          ]
        }
      ]
    },
    {
      id: "eC35",
      name: "eC35",
      description: "Eficiencia, capacidad y sustentabilidad. Furgón 100% eléctrico con buena autonomía, espacio de carga útil y equipamiento moderno para uso comercial.",
      image: require("assets/images/dfsk/full/ec35.png"),
      section: [
        {
          title: "Exterior / Capacidad",
          description: "Volumen de carga amplio con portón trasero, espacio libre útil para transporte comercial eficiente.",
          caracteristics: [
            {
              title: "Volumen de carga de 5 m³",
              description: "Espacio libre de carga útil de 5 metros cúbicos, ideal para mercancías y distribución."
            },
            {
              title: "Portón trasero amplio",
              description: "Portón trasero con apertura para facilitar carga y descarga."
            }
          ]
        },
        {
          title: "Autonomía y rendimiento eléctrico",
          description: "Batería de capacidad adecuada, buen rango WLTP, carga rápida y eficiencia energética para uso diario.",
          caracteristics: [
            {
              title: "Batería de 38,7 kWh",
              description: "Capacidad de batería eléctrica de 38,7 kWh."
            },
            {
              title: "Autonomía WLTP hasta 245 km",
              description: "Rango eléctrico estimado bajo ciclo WLTP de hasta 245 km."
            },
            {
              title: "Rendimiento energético ~4,1 km/kWh",
              description: "Consumo estimado de unos 4,1 kilómetros por kWh."
            },
            {
              title: "Carga rápida 20-80%",
              description: "Tiempo aproximado de 1 hora y 30 minutos para cargar del 20 al 80%."
            }
          ]
        },
        {
          title: "Interior / Confort",
          description: "Tablero digital, extras multimedia, pantalla táctil y comodidades para el conductor y acompañante.",
          caracteristics: [
            {
              title: "Tablero digital",
              description: "Panel digital de instrumentos que muestra nivel de carga de batería."
            },
            {
              title: "Pantalla táctil de 9\"",
              description: "Pantalla 9 pulgadas para radio, teléfono, multimedia y cámara de retroceso."
            },
            {
              title: "Interior amplio con extras multimedia",
              description: "Habitáculo pensado para confort en jornadas prolongadas de uso comercial."
            }
          ]
        },
        {
          title: "Seguridad",
          description: "Airbags, visibilidad mejorada, iluminación LED trasera y elementos pasivos para seguridad integral.",
          caracteristics: [
            {
              title: "Airbags",
              description: "Protección para conductor y acompañante."
            },
            {
              title: "Faros delanteros estilo diamante",
              description: "Mejor visibilidad frontal en condiciones adversas."
            },
            {
              title: "Luces traseras LED",
              description: "Tecnología LED en faros traseros para mejor visibilidad."
            }
          ]
        }
      ]
    }
];

export default products;
